<template>
  <div>
    <iframe
      ref="metricsIframe"
      @load="onMetricsIframeLoad"
      :src="flows_metrics_dashboard"
      v-bind:style="{ width: '1px', minWidth: '100%', marginTop: '-25px' }"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import iFrameResize from "iframe-resizer/js/iframeResizer";
import {
  FLOWS_URL,
  FLOWS_METRICS_DASHBOARD,
  FLOWS_METRICS_TENANT,
} from "@/common/config";
import qs from "qs";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vue Bootstrap", route: "alert" },
      { title: "Metrics" },
    ]);
  },
  data() {
    return {
      flows_metrics_dashboard:
        FLOWS_URL +
        qs.stringify(
          {
            security_tenant: FLOWS_METRICS_TENANT,
            token: this.$store.getters.currentUser.access_token,
          },
          { addQueryPrefix: true }
        ) +
        "#/dashboard/" +
        FLOWS_METRICS_DASHBOARD +
        qs.stringify(
          {
            embed: true,
          },
          { addQueryPrefix: true }
        ),
    };
  },
  methods: {
    onMetricsIframeLoad: function() {
      iFrameResize(
        {
          heightCalculationMethod: "taggedElement",
          bodyBackground: "#f2f3f8",
          warningTimeout: 0,
        },
        this.$refs.metricsIframe
      );
    },
  },
};
</script>
